export { DynamicPage } from './dynamic-page';
